// import { useEffect } from "react";

// const GTM_ID = "GTM-N6RT23ZJ";

// export default function GTM() {
//   useEffect(() => {
//     if (typeof window === "undefined" || typeof document === "undefined") return;

//     if (window.__GTM_LOADED__) return;
//     window.__GTM_LOADED__ = true;

//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({
//       "gtm.start": new Date().getTime(),
//       event: "gtm.js",
//     });

//     const script = document.createElement("script");
//     script.async = true;
//     script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
//     document.head.appendChild(script);

//     window.dataLayer.push({
//       event: "page_view",
//       page_path: window.location.pathname,
//       page_title: document.title,
//       page_location: window.location.href,
//     });
//   }, []);

//   return null;
// }

import { useEffect } from "react";

export default function GTM() {
  useEffect(() => {
    const GTM_ID = "GTM-N6RT23ZJ";

    // evita duplicar (React StrictMode / hot reload)
    if (window.__GTM_LOADED__) return;
    window.__GTM_LOADED__ = true;

    // garante dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // injeta o script do GTM no <head>
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
  }, []);

  return null;
}
